import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() {
  }

  public get(key) {
    return localStorage.getItem(key);
  }

  public set(key, value) {
    localStorage.setItem(key, value);
  }

  public clear(key: string) {
   localStorage.removeItem(key);
  }
}
